import React from 'react';
import NewsItem from "./NewsItem";
import BenefitItem from "./BenefitItem";
import { notifyUser } from '../util/util';
import { ChevronRight } from 'lucide-react';

const DashboardNews = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8" style={{ position: 'relative', zIndex: 10, }}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
        <section className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
          <h3 className="font-bold text-lg mb-6">Exclusive Announcements</h3>
          <div className="space-y-8">
            <NewsItem 
              title="New Premium Wellness Program" 
              desc="Unlock a world of well-being with our new premium program, offering rejuvenating retreats." 
              date="24 Feb 2023 • 13:56" 
            />
            <NewsItem 
              title="Global Coverage Expansion" 
              desc="We've expanded our coverage to over 75 new global destinations." 
              date="24 Feb 2023 • 13:56" 
            />
          </div>
          <button onClick={() => notifyUser('info', 'Coming soon!', 'Info')} className="mt-8 text-sm font-bold flex items-center gap-2 hover:gap-3 transition-all">
            VIEW MORE <ChevronRight size={16} />
          </button>
        </section>
        
        <section className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
          <h3 className="font-bold text-lg mb-6">Benefits Available</h3>
          <div className="space-y-6">
            <BenefitItem 
              title="Airport Lounge Access" 
              info="8 remaining visits to Kubatana Lounge." 
              status="Available" 
            />
            <BenefitItem 
              title="Annual Health Screening" 
              info="Expires on March 15, 2025." 
              status="Available" 
            />
            <BenefitItem 
              title="Complimentary Wi-Fi" 
              info="Get up to 5GB on your next trip." 
              status="Available" 
            />
          </div>
          <button onClick={() => notifyUser('info', 'Coming soon!', 'Info')} className="mt-8 text-sm font-bold flex items-center gap-2 hover:gap-3 transition-all">
            VIEW MORE <ChevronRight size={16} />
          </button>
        </section>
      </div>
    </div>
  );
};

export default DashboardNews;